import { Typography, TextStylePreset } from '@vivaldis/antd-ui'
import { useTranslation } from 'react-i18next'
import { List } from 'antd'
import { Divider } from '../../../Divider'
import {
  EmployeeProfileQuery_employee,
  EmployeeProfileQuery_employee_educations as Education
} from '../../typings/EmployeeProfileQuery'
import { EducationListItem } from './components/EducationListItem'

export interface EducationsProps {
  employee: EmployeeProfileQuery_employee
}

export const Educations = ({ employee }: EducationsProps) => {
  const [t] = useTranslation('web_ui')

  const { educations } = employee

  if (!educations.length) {
    return null
  }

  return (
    <>
      <Typography.Paragraph
        preset={TextStylePreset.Semibold16}
        marginTop={24}
        marginBottom={16}
      >
        {t('employee_profile.education_header', {
          count: educations.length
        })}
      </Typography.Paragraph>
      <List<Education>
        itemLayout="horizontal"
        dataSource={educations}
        renderItem={education => (
          <EducationListItem key={education.id} education={education} />
        )}
      />
      <Divider sectionSeparator />
    </>
  )
}
